import { t } from '@/features/i18n/utils';
import { WorkspaceBreadcrumbs } from '@/features/workspaces/components/workspace-breadcrumbs';
import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderChatButton, HeaderBackButton } from '@/ui/components/header';
import { procurementsQuery } from '@/features/subcontractor-bids/queries';
import { WorkPackagesLayout } from '@/features/work-packages/components/work-packages-layout';
import { WorkPackagesPage } from '@/features/work-packages/components/work-packages-page';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/work-packages',
)({
  staticData: { chatSurface: 'kg_work_package' },
  component: RouteComponent,
  loader: ({ context, params }) =>
    context.queryClient.query({ ...procurementsQuery(params.workspaceId), staleTime: 'static' }),
  validateSearch: z.object({
    commentEntityId: z.string().optional(),
    packageId: z.string().optional(),
  }),
});

function RouteComponent() {
  const { workspaceId, projectId } = Route.useParams();

  return (
    <>
      <Header>
        <HeaderBackButton
          to="/project/$projectId/workspaces/$workspaceId/scope-breakdown"
          params={{ projectId, workspaceId }}
        />
        <WorkspaceBreadcrumbs>
          <BreadcrumbPage>{t({ en: 'Work packages', nb: 'Arbeidspakker' })}</BreadcrumbPage>
        </WorkspaceBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <WorkPackagesLayout>
        <WorkPackagesPage />
      </WorkPackagesLayout>
    </>
  );
}
